// import { useLocation } from "react-router-dom";
// import { GetDataMenuData } from "./data-storage";

// const CheckTokenExpire = (tokens) => {
//     const decodeJwt = ParseJwt(tokens);
//     if((decodeJwt.exp * 1000) < Date.now()){
//         return true;
//     }
//     return false;
// };

// const ParseJwt = (token) => {
//     try {
//         return JSON.parse(atob(token.split(".")[1]));
//     } catch (e) {
//         return null;
//     }
// };

// const GetAuthInPage = () => {
//     const location = useLocation();
//     const menuData = GetDataMenuData();
//     let arrMenu = JSON.parse(atob(menuData));
//     let localPathName = ConvertPathLocalToMenu(location.pathname);
//     const haveMenu = arrMenu.find((obj) => obj.screen.page_url === localPathName);
//     return (typeof(haveMenu) === "undefined") ? null : haveMenu;
// };

// const ConvertPathLocalToMenu = (urlLocal) => {
//     let localPathName = urlLocal.replace("/", "");
//     let arrLocalPathName = localPathName.split("/");
//     localPathName = (arrLocalPathName.length > 2) ? "/" + arrLocalPathName[0] + "/" + arrLocalPathName[1] + "/param" : "/" + localPathName;
//     return localPathName;
// }

// export { CheckTokenExpire, ParseJwt, GetAuthInPage };

import { useLocation } from "react-router-dom";
import { GetDataMenuData } from "./data-storage";

const CheckTokenExpire = (tokens) => {
    const decodeJwt = ParseJwt(tokens);
    if((decodeJwt.exp * 1000) < Date.now()){
        return true;
    }
    return false;
};

const ParseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};

// ถ้าเพิ่มเมนู static ใหม่ใน sidebar ให้เพิ่ม path ตรงนี้ด้วย
const STATIC_AUTH_PATHS = [
    "/admin/recurrent",
];

const GetAuthInPage = () => {
    const location = useLocation();
    const menuData = GetDataMenuData();
    let arrMenu = JSON.parse(atob(menuData));
    let localPathName = ConvertPathLocalToMenu(location.pathname);

    // ถ้าเป็น static path ให้ผ่านได้เลย ไม่ต้องเช็ค API menu
    if (STATIC_AUTH_PATHS.includes(location.pathname)) {
        return { is_static: true };
    }

    const haveMenu = arrMenu.find((obj) => obj.screen.page_url === localPathName);
    return (typeof(haveMenu) === "undefined") ? null : haveMenu;
};

const ConvertPathLocalToMenu = (urlLocal) => {
    let localPathName = urlLocal.replace("/", "");
    let arrLocalPathName = localPathName.split("/");
    localPathName = (arrLocalPathName.length > 2) ? "/" + arrLocalPathName[0] + "/" + arrLocalPathName[1] + "/param" : "/" + localPathName;
    return localPathName;
}

export { CheckTokenExpire, ParseJwt, GetAuthInPage };